import Head from 'next/head'
import { useRouter } from 'next/router'

const BASE_URL = 'https://atendimento.flashapp.com.br'

type FlowHeadProps = {
  title: string
  description: string
}

export function FlowHead({ title, description }: FlowHeadProps) {
  const { pathname } = useRouter()

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} key="description" />
      <link rel="canonical" href={`${BASE_URL}${pathname}`} key="canonical" />
    </Head>
  )
}
